// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Drawer that displays a fulfillment order's audit log — the chronological list
 * of lifecycle, field-edit, and third-party events recorded for the order.
 */
import { AuditDrawer } from '@/components/audit-drawer';
import { FulfillmentAuditList } from '@/fulfillment/components/fulfillment-audit-list';

interface Props {
  fulfillmentKey: string;
  disclosure: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
}

export function FulfillmentAuditDrawer(props: Props) {
  return (
    <AuditDrawer
      title="Fulfillment order audit log"
      disclosure={props.disclosure}
      auditLog={<FulfillmentAuditList fulfillmentKey={props.fulfillmentKey} />}
    />
  );
}
